import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { domainUrl } from '../../../constants'
import { checkAuthorization } from '../../../helpers';
import { message } from 'antd'

export const getFaqApi = createAsyncThunk('getFaqStatistics',
    async (object, { dispatch, getState }) => {

        const {userToken}= checkAuthorization()
        dispatch(gettingAddFaqDetail())
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        myHeaders.append("pageNO", object?.pageNo)
        myHeaders.append("recordsPerPage", object?.pageSize)
        var requestOptions = {
            method: 'Post',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({name: object?.name})
        };
        fetch(domainUrl + `/viewAllFaqs`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    dispatch(faqDetailResponse(result?.data))
                    dispatch(setPages({pageNo: object?.pageNo, pageSize: object?.pageSize, totalRecords: result?.totalRecords}))
                }
                else 
                    throw result?.message
            })
            .catch(error => { 
                dispatch(faqDetailClear())
                message.error(error) 
            })
    }
)


export const updateFaqStatus = createAsyncThunk('getStatusStatistics',
    async (object, { dispatch, getState }) => {

        const { userToken } = checkAuthorization()
        var myHeaders = new Headers();
        myHeaders.append("Authorization", userToken)
        myHeaders.append("Content-Type", "application/json")
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            redirect: 'follow',
            body: JSON.stringify({ id: object?.id, status: object?.status })
        };
        fetch(domainUrl + `/updateFaqStatus`, requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result?.success) {
                    const data = result?.data;
                    dispatch(faqstatusResponse({id: data?.id, status: data?.status}))
                }
                else
                    throw result?.message
            })
            .catch(error => {
                message.error(error)
            })
    }
)


const AddFaqSlice = createSlice({
    name: 'Faqsgetapi',
    initialState: {
        faqData: null,
        loadingfaq: false,
        pagination:{
            pageNo:1,
            pageSize: 10,
            totalRecords:0,
        },
        filters: {
            name: '',
            id: '',
            status: '',
        },
    },
    reducers: {
        gettingAddFaqDetail: state => {
            state.loadingfaq=true
            state.faqData=null
        },
        faqDetailResponse: (state, action)=>{
            state.faqData= action.payload
            state.loadingfaq= false
        },
        faqDetailClear: (state)=>{
            state.faqData= null
            state.loadingfaq= false
        },
        changeFaqDetailFilters: (state, action) => {
            state.filters = action.payload
        },
        setPages:(state, action)=>{
            state.pagination= action.payload
        },
        faqstatusResponse: (state, action) => {
            const { id, status } = action.payload
            const faqIndex = state.faqData.findIndex(faq => faq.id === id)
            if (faqIndex !== -1) {
                state.faqData[faqIndex].status = status
            }
            state.loadingfaq = false
        }
    },
})
export const { 
    gettingAddFaqDetail, faqDetailResponse, faqDetailClear,
    changeFaqDetailFilters, setPages, faqstatusResponse
} = AddFaqSlice.actions;
export default AddFaqSlice.reducer;